import * as React from 'react';
import { Card } from "react-bootstrap";
import './PolicyBanner.css';


export interface PolicyBannerInterface {
    policyName: string;
    nextDebitOrderDate: string;
    title: string;
}

export class PolicyBanner extends React.Component<PolicyBannerInterface, any> {
        constructor(props: PolicyBannerInterface) {
            super(props);
        }
        
       public render() {
            return (
                <Card className="mb-2">
                    <Card.Body className="policy-banner__card-body">
                        <div className="row justify-content-between h-100 align-items-center policy-banner__box mx-1">
                            <h2 className="col-12 col-md-6 col-lg-12 col-xl-6 px-0 px-xl-3 mb-0 policy-banner__text policy-banner__title pb-2 pb-sm-0"><b>{ this.props.title }</b></h2>
                            <div className="col-12 col-md-6 col-lg-12 col-xl-6 mt-3 mt-sm-0 px-0 row justify-content-start justify-content-lg-between">
                                <div className="col-6 col-md-5">
                                    <p className="mb-0 policy-banner__text policy-banner__sub-text">Next debit order</p>
                                    <p className="mb-0 font-weight-bold policy-banner__text policy-banner__main-text"><b>{ this.props.nextDebitOrderDate ? this.props.nextDebitOrderDate : 'N/A' }</b></p>
                                </div>
                                <div className="col-6 col-md-5">
                                    <p className="mb-0 policy-banner__text policy-banner__sub-text">Policy no.</p>
                                    <p className="mb-0 font-weight-bold policy-banner__text policy-banner__main-text"><b>{ this.props.policyName }</b></p>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            )
       }
}